import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from 'src/shared/user.service';

@Injectable()
export class RewriteGuard implements CanActivate {
  #userService = inject(UserService);
  #router = inject(Router);

  canActivate(): boolean | UrlTree {
    const user = this.#userService.user;
    const hasPermission = user?.permissions?.policy?.admin;
    const isFeatureToggleEnabled = user?.featureToggles.intelligentRewriteWorkflowEnabled;

    if (hasPermission && isFeatureToggleEnabled) {
      return true;
    }
    return this.#router.createUrlTree(['errors', '403']);
  }
}
